var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_4419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1230_4419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 87,
    height: 87
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000259399H86.9997V87H0V0.000259399Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1230_4419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5793 3.43362H27.5587C22.254 3.43362 17.9074 7.78018 17.9074 13.0847V15.3792H58.9417C65.9032 15.3792 71.5927 21.0687 71.5927 28.0303V54.3308H74.5793C79.8841 54.3308 84.2304 49.9844 84.2304 44.6797V13.0847C84.2304 7.78015 79.8841 3.43362 74.5793 3.43362Z",
    fill: "#3F51B5",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6731 16.3695H19.6524C18.5526 16.3692 17.4589 16.533 16.4074 16.8555V16.8793H58.9416C65.0748 16.8793 70.0927 21.8974 70.0927 28.0304V55.8311H74.5793C75.6791 55.8313 76.7727 55.6676 77.8242 55.3453V27.5206C77.8242 21.3877 72.8062 16.3695 66.6731 16.3695Z",
    fill: "#4F67D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3329 71.2348L56.333 71.2348C57.099 70.2989 58.2482 69.7667 59.4515 69.7667C65.3085 69.7667 70.1026 64.9726 70.1026 59.1154V27.5206C70.1026 21.6636 65.3085 16.8695 59.4515 16.8695H12.4309C6.57388 16.8695 1.77963 21.6636 1.77963 27.5206V59.1154C1.77963 64.9726 6.57389 69.7667 12.4309 69.7667H40.652C42.1799 69.7667 43.3263 71.1888 42.975 72.6846C42.2186 75.9052 41.0611 79.3105 39.3507 82.8001C38.8084 83.9065 40.0398 85.0158 41.0768 84.374C45.2965 81.7626 51.2907 77.3972 56.3329 71.2348Z",
    fill: "#60B8FE",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7098 72.5703C49.9865 71.3924 49.0833 70.2667 47.8735 70.2667H40.6518C41.8617 70.2667 42.7648 71.3924 42.4882 72.5703C41.7398 75.7565 40.5946 79.1261 38.9016 82.58C38.1414 84.1314 39.8709 85.7083 41.3398 84.7992C43.2437 83.6203 45.0884 82.3482 46.867 80.9877C48.1588 78.0907 49.0769 75.2648 49.7098 72.5703Z",
    fill: "#23A8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50117 59.1156V27.5208C8.50117 21.3877 13.5191 16.3695 19.6523 16.3695H12.4306C6.29746 16.3695 1.27951 21.3877 1.27951 27.5208V59.1156C1.27951 65.2488 6.29746 70.2667 12.4306 70.2667H19.6523C13.5191 70.2667 8.50117 65.2488 8.50117 59.1156Z",
    fill: "#23A8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4373 44.2254C20.4373 46.269 18.7806 47.9258 16.7369 47.9258C14.6933 47.9258 13.0365 46.269 13.0365 44.2254C13.0365 42.1818 14.6933 40.5252 16.7369 40.5252C18.7806 40.5252 20.4373 42.1818 20.4373 44.2254Z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3891 44.2254C32.3891 46.269 30.7323 47.9258 28.6887 47.9258C26.645 47.9258 24.9883 46.269 24.9883 44.2254C24.9883 42.1818 26.645 40.5252 28.6887 40.5252C30.7323 40.5252 32.3891 42.1818 32.3891 44.2254Z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.341 44.2254C44.341 46.269 42.6842 47.9258 40.6406 47.9258C38.597 47.9258 36.9402 46.269 36.9402 44.2254C36.9402 42.1818 38.597 40.5252 40.6406 40.5252C42.6842 40.5252 44.341 42.1818 44.341 44.2254Z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2926 44.2254C56.2926 46.269 54.6358 47.9258 52.5922 47.9258C50.5485 47.9258 48.8918 46.269 48.8918 44.2254C48.8918 42.1818 50.5485 40.5252 52.5922 40.5252C54.6358 40.5252 56.2926 42.1818 56.2926 44.2254Z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7371 44.2254C16.7371 42.856 17.4815 41.6613 18.5872 41.0214C18.0251 40.6956 17.3868 40.5243 16.7371 40.525C14.6934 40.525 13.0367 42.1818 13.0367 44.2254C13.0367 46.269 14.6934 47.9258 16.7371 47.9258C17.4113 47.9258 18.0429 47.7445 18.5872 47.4294C17.4815 46.7895 16.7371 45.5948 16.7371 44.2254Z",
    fill: "#B1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6887 44.2254C28.6887 42.856 29.4331 41.6613 30.5388 41.0214C29.9767 40.6956 29.3384 40.5243 28.6887 40.525C26.645 40.525 24.9883 42.1818 24.9883 44.2254C24.9883 46.269 26.645 47.9258 28.6887 47.9258C29.3629 47.9258 29.9945 47.7445 30.5388 47.4294C29.4331 46.7895 28.6887 45.5948 28.6887 44.2254Z",
    fill: "#B1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6404 44.2254C40.6404 42.856 41.3849 41.6613 42.4905 41.0214C41.9284 40.6956 41.2901 40.5243 40.6404 40.525C38.5968 40.525 36.9401 42.1818 36.9401 44.2254C36.9401 46.269 38.5968 47.9258 40.6404 47.9258C41.3147 47.9258 41.9463 47.7445 42.4905 47.4294C41.3849 46.7895 40.6404 45.5948 40.6404 44.2254Z",
    fill: "#B1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5924 44.2254C52.5924 42.856 53.3368 41.6613 54.4425 41.0214C53.8804 40.6956 53.2421 40.5243 52.5924 40.525C50.5487 40.525 48.892 42.1818 48.892 44.2254C48.892 46.269 50.5487 47.9258 52.5924 47.9258C53.2666 47.9258 53.8982 47.7445 54.4425 47.4294C53.3368 46.7895 52.5924 45.5948 52.5924 44.2254Z",
    fill: "#B1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6572 70.2667H40.6466C41.8566 70.2667 42.7597 71.3924 42.4829 72.5703C41.7346 75.7565 40.5893 79.1261 38.8965 82.58C38.1361 84.1314 39.8658 85.7083 41.3347 84.7992C45.5823 82.1705 51.6253 77.7711 56.7147 71.5516C57.3836 70.734 58.3898 70.2667 59.4463 70.2667C65.5793 70.2667 70.5974 65.2487 70.5974 59.1156V27.5206C70.5974 21.3875 65.5793 16.3695 59.4463 16.3695H12.4255C6.29236 16.3695 1.27441 21.3875 1.27441 27.5206V59.1156C1.27441 65.2487 6.29236 70.2667 12.4255 70.2667H25.71",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_4419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentLarge);
export default __webpack_public_path__ + "static/media/CommentLarge.e72984f258c0309f5497fcd7380cccbe.svg";
export { ForwardRef as ReactComponent };